export enum EShareRoutes {
  SHARE = 'Share'
}
